import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import { faSave, faCat, faCheckSquare, faBan, faPrint, faTrashRestore, faBookmark, faCode, faSlash, faAirFreshener, faPlusCircle, faClipboardList, faShareAltSquare} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";



export default class ModalActionMenuPanel extends Component {
    constructor(props) {
      super(props);
      this.state ={}

      this.makeMenuItem = this.makeMenuItem.bind(this);
    }

    makeMenuItem(dataTip, icon, label, onClickEvent, readOnly=false)
    {
        return <p data-tip={dataTip}>
                <Button
                    disabled={readOnly}
                    onClick={onClickEvent}
                >
                    <FontAwesomeIcon icon={icon} />
                    &nbsp; {label}
                </Button>
        </p>
    }


    render()
    {
        const gridMenu = [
            this.makeMenuItem("Add New Receipt", faPlusCircle, "new receipt", this.props.onAddReceiptPageRequest, this.props.readOnly),
            this.makeMenuItem("Void Receipt", faBan, "void receipt", this.props.onVoidRequest),
            this.makeMenuItem("Repost Receipt", faCat, "resend to famous", this.props.onRepostTagRequest),
            this.makeMenuItem("Reprint Pallet Tags", faPrint, "reprint tags", this.props.onReprintTagsRequest),
            this.makeMenuItem("Mark Complete", faCheckSquare, "mark complete", this.props.onMarkCompleteRequest),
            this.makeMenuItem("View Quarantined Pallets", faAirFreshener, "quarantined", this.props.onQuarantinePageRequest, this.props.readOnly),
            this.makeMenuItem("View selected observation detail", faCode, "details", this.props.onDetailViewRequest),
            this.makeMenuItem("View selected observation log", faClipboardList, "log", this.props.onLogViewRequest),
            this.makeMenuItem("Resend Notifications", faShareAltSquare, "resend notifications", this.props.onResendNotificationsRequest),
            this.makeMenuItem("Close this Menu", faSlash, "close", this.props.onCloseMenuRequest)
        ];

        const gridLayout = [
            this.makeMenuItem("Save Layout", faSave, "save layout", this.props.onSaveLayoutRequest),
            this.makeMenuItem("Reset Layout", faTrashRestore, "reset layout", this.props.onResetLayoutRequest),
            this.makeMenuItem("Restore Layout", faBookmark, "restore layout", this.props.onRestoreLayoutRequest), 
            this.makeMenuItem("Close this Menu", faSlash, "close", this.props.onCloseMenuRequest)
        ];


        return(
            <Modal.Body>
                {(this.props.modalType==="gridmenu") ? gridMenu : gridLayout}

        
            </Modal.Body>
        )
    }

}


